import React from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';

import './TagList.scss';

export default class TagList extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    removeSelection: PropTypes.func,
    toggleFriendSelection: PropTypes.func,
    addFriendSelectionOnEnterPress: PropTypes.func,
    value: PropTypes.string,
    selectedItems: PropTypes.object,
    allFriends: PropTypes.object,
    removeFriendSelection: PropTypes.func,
    placeholder: PropTypes.string,
    selectedIds: PropTypes.object,
  };

  static defaultProps = {
    removeSelection: () => {},
    toggleFriendSelection: () => {},
    addFriendSelectionOnEnterPress: () => {},
    value: '',
    placeholder: '',
    onChange: () => {},
    selectedItems: Immutable.List(),
    allFriends: Immutable.List(),
    removeFriendSelection: () => {},
    selectedIds: Immutable.List(),
  };

  state = {
    itemTabIndex: 0,
  }

  onTagListKeyUp = (event) => {
    this.removeFriendSelectionOnBackspace(event);
    this.handleEnterPress(event.keyCode);
    this.handleArrowKeys(event);
  }

  toggleFriendSelection = (event) => {
    event.preventDefault();
    const { toggleFriendSelection } = this.props;

    toggleFriendSelection(event);
  }

  removeFriendSelectionOnBackspace(event) {
    const { selectedItems, removeFriendSelection } = this.props;
    const backSpaceKeyCode = 8;
    const inputVal = event.currentTarget.value;

    if (event.keyCode === backSpaceKeyCode && inputVal === '' && !this.oldInputVal && selectedItems.size > 0) {
      removeFriendSelection(selectedItems.last());
    }

    this.oldInputVal = inputVal;
  }

  handleEnterPress(keyCode) {
    const { addFriendSelectionOnEnterPress, value } = this.props;
    const enterKey = 13;
    const firstFriendId = this.filteredFriends.getIn([this.state.itemTabIndex, 'id']);

    if (keyCode === enterKey && firstFriendId && value) {
      addFriendSelectionOnEnterPress(firstFriendId);
      this.oldInputVal = '';
    }
  }

  handleArrowKeys(event) {
    const keyCode = event.keyCode;
    const upKey = 38;
    const downKey = 40;

    if (keyCode === upKey && this.state.itemTabIndex > 0) {
      this.setState({
        itemTabIndex: this.state.itemTabIndex - 1,
      });
    } else if (keyCode === downKey && this.state.itemTabIndex < this.filteredFriends.size) {
      this.setState({
        itemTabIndex: this.state.itemTabIndex + 1,
      });
    } else {
      this.setState({
        itemTabIndex: 0,
      });
    }
  }

  render() {
    const {
      selectedIds,
      selectedItems,
      allFriends,
      removeSelection,
      placeholder,
      value,
      onChange,
    } = this.props;
    const lowerCasedFriendsFilterText = value.toLowerCase();
    this.filteredFriends = allFriends.size ?
      allFriends.filter((friend) =>
        friend.get('name').toLowerCase().includes(lowerCasedFriendsFilterText) && !selectedIds.includes(friend.get('id')),
      )
      : Immutable.List();

    return (
      <div className="tag-list">
        <div className="tag-list__list__wrapper">
          <label className="tag-list__inner" htmlFor="tag-list__input">
            <ul className="tag-list__list">
              { selectedItems.map((friend) => (
                <li key={friend.get('id')} className="tag-list__list__item">
                  <a href="" className="tag-list__list__item__btn" onClick={removeSelection} data-id={friend.get('id')}>
                    { friend.get('name') }
                    <i className="tag-list__list__item__cross-icon" />
                  </a>
                </li>
              ))}
            </ul>
            <input
              type="text"
              id="tag-list__input"
              className="tag-list__input"
              autoFocus={window.innerWidth >= 768}
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              onKeyUp={this.onTagListKeyUp}
            />
          </label>

          { this.props.value.length > 0 && (
            <div>
              { this.filteredFriends.size ? (
                <ul className="tag-list__suggestions">
                  { this.filteredFriends.map((friend, index) => (
                    <li key={friend.get('id')} className="tag-list__suggestions__item">
                      <a
                        href=""
                        className={`tag-list__suggestions__item__btn ${this.state.itemTabIndex === index && '--active'}`}
                        onClick={this.toggleFriendSelection} data-id={friend.get('id')}
                      >
                        <div className="tag-list__suggestions__item__btn__inner">
                          <img src={friend.getIn(['picture', 'data', 'url'])} alt="" />
                          { friend.get('name') }
                        </div>
                      </a>
                    </li>
                  ))}
                </ul>
              ) : (
                <div className="tag-list__suggestions__no-matches">There are no friends that match your search</div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/TagList/TagList.js